module.exports = __webpack_public_path__ + "static/media/boy3.d369c528.svg";